// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

import {
    CancellationEventArgsBase,
} from "./CancellationEventArgsBase.js";

export class SpeechRecognitionCanceledEventArgs extends CancellationEventArgsBase {
}
